import { render, staticRenderFns } from "./ResetPasswordRequest.vue?vue&type=template&id=ff86fef2&scoped=true&"
import script from "./ResetPasswordRequest.vue?vue&type=script&lang=js&"
export * from "./ResetPasswordRequest.vue?vue&type=script&lang=js&"
import style0 from "./ResetPasswordRequest.vue?vue&type=style&index=0&id=ff86fef2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff86fef2",
  null
  
)

export default component.exports